module.exports = __webpack_public_path__ + "static/media/munster-technological-university.d561917a.jpeg";